import { RichText } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import { JobPostSection } from '..';
import { StyledSection } from '../styles';
import type { AboutTheProjectProps } from './AboutTheProject.types';

export const AboutTheProject: FC<AboutTheProjectProps> = ({
  aboutTheProject,
}) => {
  return (
    <StyledSection>
      <JobPostSection
        banner="About the project"
        title="What project you’ll be working on?">
        <RichText
          content={aboutTheProject}
          contentPrimary
          reverseMargin={aboutTheProject.startsWith('<div><p')}
        />
      </JobPostSection>
    </StyledSection>
  );
};
